import React from "react";
import { Button as ButtonUntyped } from "../../primary";
import PlusIcon from "../../../static/images/plus-icon_white.svg";
import styles from "./assign.module.scss";

const Button = ButtonUntyped as unknown as React.ComponentType<{
  classes?: Record<string, string>;
  type?: string;
  onClick?: () => void;
  children: React.ReactNode;
}>;

interface FormHeaderProps {
  onAddSection: () => void;
  onAddQuestion: () => void;
  unSectionedQuestions?: unknown[];
}

const FormHeader: React.FC<FormHeaderProps> = ({ onAddSection, onAddQuestion, unSectionedQuestions }) => {
  return (
    <div className={`d-flex justify-content-end mb-2`}>
      {unSectionedQuestions?.length === 0 && (
        <Button classes={{ className: `btn ${styles.btn_customs} ${styles.btn_smalls}` }} type="button" onClick={() => onAddQuestion()}>
          <img src={PlusIcon} alt="addQuestion" />
          Add Question
        </Button>
      )}
      <Button classes={{ className: `btn ${styles.btn_customs} ${styles.btn_smalls}` }} type="button" onClick={onAddSection}>
        <img src={PlusIcon} alt="addSection" />
        Add Section
      </Button>
    </div>
  );
};

export default FormHeader;
